// frontend/app/NotificationContext.js
import React, { createContext, useContext, useState } from 'react';
import { Snackbar } from 'react-native-paper';
import { Platform } from 'react-native';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info'); // 'success', 'error', 'warning', 'info'
  const [duration, setDuration] = useState(3000);

  const showNotification = (msg, notifType = 'info', customDuration = 3000) => {
    setMessage(msg);
    setType(notifType);
    setDuration(customDuration);
    setVisible(true);
  };

  const hideNotification = () => {
    setVisible(false);
  };

  // Color based on notification type
  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#4CAF50'; // Green
      case 'error':
        return '#F44336'; // Red
      case 'warning':
        return '#FF9800'; // Orange
      case 'info':
      default:
        return '#2196F3'; // Blue
    }
  };

  return (
    <NotificationContext.Provider value={{ showNotification, hideNotification }}>
      {children}
      <Snackbar
        visible={visible}
        onDismiss={hideNotification}
        duration={duration}
        wrapperStyle={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
        }}
        style={{
          backgroundColor: getBackgroundColor(),
          ...(Platform.OS === 'web' && {
            maxWidth: 500,
            alignSelf: 'center',
          }),
        }}
        action={{
          label: '✕',
          onPress: hideNotification,
          textColor: '#FFFFFF',
        }}
      >
        {message}
      </Snackbar>
    </NotificationContext.Provider>
  );
};